// Mxltiverse — i18n strings bundled in frontend (no API needed)
import type { Language } from '@mxltiverse/shared';

export type Lang = Language;

export type StringKey =
  | 'tagline' | 'play' | 'continue' | 'connecting' | 'backend_ok'
  | 'register' | 'login' | 'full_name' | 'gender' | 'male' | 'female' | 'no_specify'
  | 'birth_year' | 'email' | 'otp_code' | 'back' | 'send_code' | 'access'
  | 'verify' | 'otp_sent_email' | 'otp_sent_dev' | 'authenticated'
  | 'register_tab' | 'login_tab'
  | 'choose_universe' | 'choose_genre' | 'duration' | 'loading'
  | 'create_character' | 'hero_name' | 'choose_archetype' | 'allocate_stats'
  | 'points_left' | 'background_optional' | 'bg_placeholder'
  | 'start_adventure' | 'starting_abilities' | 'enter_name_first'
  | 'turn' | 'save' | 'exit' | 'write_action' | 'act'
  | 'defeat' | 'the_end' | 'retry' | 'home'
  | 'hero_fell' | 'story_concluded'
  | 'your_games' | 'no_saves' | 'new_game' | 'delete' | 'confirm_delete'
  | 'music_on' | 'music_off' | 'connected' | 'disconnected'
  | 'click_skip' | 'progress'
  ;

const STRINGS: Record<StringKey, Record<Lang, string>> = {
  tagline: { es: 'RPG de texto — 8-bit — IA narrativa', en: 'Text RPG — 8-bit — AI storytelling', pt: 'RPG de texto — 8-bit — IA narrativa' },
  play: { es: 'JUGAR', en: 'PLAY', pt: 'JOGAR' },
  continue: { es: 'CONTINUAR', en: 'CONTINUE', pt: 'CONTINUAR' },
  connecting: { es: 'Conectando...', en: 'Connecting...', pt: 'Conectando...' },
  backend_ok: { es: 'Backend', en: 'Backend', pt: 'Backend' },

  register: { es: 'REGISTRO', en: 'REGISTER', pt: 'REGISTRO' },
  login: { es: 'ACCESO', en: 'LOGIN', pt: 'ACESSO' },
  full_name: { es: 'Nombre completo', en: 'Full name', pt: 'Nome completo' },
  gender: { es: 'Genero', en: 'Gender', pt: 'Gênero' },
  male: { es: 'Hombre', en: 'Male', pt: 'Masculino' },
  female: { es: 'Mujer', en: 'Female', pt: 'Feminino' },
  no_specify: { es: 'No especificar', en: 'Prefer not to say', pt: 'Não especificar' },
  birth_year: { es: 'Ano de nacimiento', en: 'Birth year', pt: 'Ano de nascimento' },
  email: { es: 'Email', en: 'Email', pt: 'Email' },
  otp_code: { es: 'Codigo de 6 digitos', en: '6-digit code', pt: 'Código de 6 dígitos' },
  back: { es: 'Volver', en: 'Back', pt: 'Voltar' },
  send_code: { es: 'ENVIAR CODIGO', en: 'SEND CODE', pt: 'ENVIAR CÓDIGO' },
  access: { es: 'ACCEDER', en: 'LOGIN', pt: 'ACESSAR' },
  verify: { es: 'VERIFICAR', en: 'VERIFY', pt: 'VERIFICAR' },
  otp_sent_email: { es: 'Codigo enviado a tu email.', en: 'Code sent to your email.', pt: 'Código enviado ao seu email.' },
  otp_sent_dev: { es: 'Email no disponible (plan free). Tu codigo:', en: 'Email unavailable (free plan). Your code:', pt: 'Email indisponível (plano grátis). Seu código:' },
  authenticated: { es: 'Autenticado!', en: 'Authenticated!', pt: 'Autenticado!' },
  register_tab: { es: 'Registrar', en: 'Register', pt: 'Registrar' },
  login_tab: { es: 'Ya tengo cuenta', en: 'I have an account', pt: 'Já tenho conta' },

  choose_universe: { es: 'ELIGE TU UNIVERSO', en: 'CHOOSE YOUR UNIVERSE', pt: 'ESCOLHA SEU UNIVERSO' },
  choose_genre: { es: 'ELIGE EL GENERO', en: 'CHOOSE THE GENRE', pt: 'ESCOLHA O GÊNERO' },
  duration: { es: 'DURACION DE LA PARTIDA', en: 'SESSION DURATION', pt: 'DURAÇÃO DA PARTIDA' },
  loading: { es: 'Cargando...', en: 'Loading...', pt: 'Carregando...' },

  create_character: { es: 'CREAR PERSONAJE', en: 'CREATE CHARACTER', pt: 'CRIAR PERSONAGEM' },
  hero_name: { es: 'Nombre del heroe', en: 'Hero name', pt: 'Nome do herói' },
  choose_archetype: { es: 'ELIGE TU ARQUETIPO', en: 'CHOOSE YOUR ARCHETYPE', pt: 'ESCOLHA SEU ARQUÉTIPO' },
  allocate_stats: { es: 'ASIGNA TUS STATS', en: 'ALLOCATE YOUR STATS', pt: 'DISTRIBUA SEUS ATRIBUTOS' },
  points_left: { es: 'puntos restantes', en: 'points remaining', pt: 'pontos restantes' },
  background_optional: { es: 'TRASFONDO (OPCIONAL)', en: 'BACKGROUND (OPTIONAL)', pt: 'HISTÓRICO (OPCIONAL)' },
  bg_placeholder: {
    es: 'Cuenta de donde viene tu personaje, sus motivaciones, su pasado...',
    en: 'Tell us where your character comes from, their motivations, their past...',
    pt: 'Conte de onde vem seu personagem, suas motivações, seu passado...'
  },
  start_adventure: { es: 'COMENZAR AVENTURA', en: 'START ADVENTURE', pt: 'COMEÇAR AVENTURA' },
  starting_abilities: { es: 'Habilidades iniciales', en: 'Starting abilities', pt: 'Habilidades iniciais' },
  enter_name_first: { es: 'Primero ingresa un nombre', en: 'Enter a name first', pt: 'Digite um nome primeiro' },

  turn: { es: 'Turno', en: 'Turn', pt: 'Turno' },
  save: { es: 'Guardar', en: 'Save', pt: 'Salvar' },
  exit: { es: 'Salir', en: 'Exit', pt: 'Sair' },
  write_action: { es: 'Escribe tu accion...', en: 'Type your action...', pt: 'Digite sua ação...' },
  act: { es: 'ACTUAR', en: 'ACT', pt: 'AGIR' },

  defeat: { es: 'DERROTA', en: 'DEFEAT', pt: 'DERROTA' },
  the_end: { es: 'FIN', en: 'THE END', pt: 'FIM' },
  retry: { es: 'REINTENTAR', en: 'RETRY', pt: 'TENTAR NOVAMENTE' },
  home: { es: 'INICIO', en: 'HOME', pt: 'INÍCIO' },
  hero_fell: { es: 'Tu heroe ha caido.', en: 'Your hero has fallen.', pt: 'Seu herói caiu.' },
  story_concluded: { es: 'La historia ha concluido.', en: 'The story has concluded.', pt: 'A história chegou ao fim.' },

  your_games: { es: 'TUS PARTIDAS', en: 'YOUR GAMES', pt: 'SUAS PARTIDAS' },
  no_saves: { es: 'No tienes partidas guardadas.', en: 'No saved games.', pt: 'Nenhuma partida salva.' },
  new_game: { es: 'Nueva partida', en: 'New game', pt: 'Nova partida' },
  delete: { es: 'Eliminar', en: 'Delete', pt: 'Eliminar' },
  confirm_delete: { es: '¿Eliminar esta partida?', en: 'Delete this game?', pt: 'Eliminar esta partida?' },

  music_on: { es: '♪on', en: '♪on', pt: '♪on' },
  music_off: { es: '♪off', en: '♪off', pt: '♪off' },
  connected: { es: 'Conectado', en: 'Connected', pt: 'Conectado' },
  disconnected: { es: 'Desconectado', en: 'Disconnected', pt: 'Desconectado' },
  click_skip: { es: '[click para saltar]', en: '[click to skip]', pt: '[clique para pular]' },
  progress: { es: 'Progreso', en: 'Progress', pt: 'Progresso' },
};

export function translate(key: StringKey, lang: Lang): string {
  return STRINGS[key]?.[lang] ?? STRINGS[key]?.en ?? key;
}
